/* Printora V27 shell interactions — visibility, announcement and mobile menu only. No layout construction. */
(() => {
  'use strict';
  if (window.__printoraV27Shell) return;
  window.__printoraV27Shell = true;

  const MOBILE_MAX = 1199;
  const DESKTOP_THRESHOLD = 6;
  const MOBILE_THRESHOLD = 1;
  const TOP_SHOW = 24;
  const PRODUCT_DESKTOP_MIN = 1200;
  const MEET_TOLERANCE = 36;
  const RELOCK_TOLERANCE = 96;
  const VIEWPORT_ALLOWANCE = 44;
  let anchorY = Math.max(0, window.scrollY || 0);
  let hidden = false;
  let ticking = false;
  let productReleased = false;
  let lastBottomDelta = null;

  const header = () => document.getElementById('printora-sticky-header');
  const y = () => Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);
  const width = () => Math.round(window.innerWidth || document.documentElement.clientWidth || 0);
  const height = () => Math.round(window.innerHeight || document.documentElement.clientHeight || 0);
  const menuOpen = () => Boolean(document.querySelector('.pv27-mobile-menu[open]'));

  function initAnnouncement() {
    const root = document.querySelector('[data-v27-announcement]');
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    /* Printora cleanup: the old V27 header shipped its own manual chevrons in
       addition to the automatic rotator. Remove those controls completely and
       collapse the old three-column/mobile-scroll layout to one clean viewport. */
    root.querySelectorAll('[data-v27-ann-prev], [data-v27-ann-next], .pv27-announcement__arrow').forEach((node) => node.remove());
    const inner = root.querySelector('.pv27-announcement__inner');
    const viewport = root.querySelector('.pv27-announcement__viewport');
    if (inner) {
      inner.style.display = 'flex';
      inner.style.gridTemplateColumns = 'minmax(0,1fr)';
      inner.style.alignItems = 'center';
      inner.style.justifyContent = 'center';
      inner.style.overflow = 'hidden';
      inner.style.width = '100%';
    }
    if (viewport) {
      viewport.style.flex = '1 1 100%';
      viewport.style.width = '100%';
      viewport.style.minWidth = '0';
      viewport.style.maxWidth = '100%';
      viewport.style.overflow = 'hidden';
      viewport.style.textAlign = 'center';
    }

    const items = [...root.querySelectorAll('[data-v27-ann-item]')].filter((item) => item.textContent.trim().length > 0);
    if (!items.length) {
      root.remove();
      return;
    }
    if (items.length < 2) {
      items[0].classList.add('is-active');
      root.dataset.ready = '1';
      return;
    }

    let index = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    let timer = null;
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const paint = (i) => {
      index = (i + items.length) % items.length;
      items.forEach((item, n) => {
        const active = n === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        item.style.display = active ? 'flex' : 'none';
        if (active) {
          item.style.alignItems = 'center';
          item.style.justifyContent = 'center';
          item.style.width = '100%';
          item.style.minWidth = '0';
        }
      });
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const start = () => { stop(); if (!reduceMotion && !document.hidden) timer = setInterval(() => paint(index + 1), 4500); };
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) start(); });
    paint(index);
    requestAnimationFrame(() => { root.dataset.ready = '1'; start(); });
  }

  function initMobileMenu() {
    const menu = document.querySelector('.pv27-mobile-menu');
    if (!menu || menu.dataset.bound === '1') return;
    menu.dataset.bound = '1';
    const close = menu.querySelector('[data-v27-menu-close]');
    const sync = () => {
      document.documentElement.classList.toggle('pv27-menu-open', menu.open);
      document.body.style.overflow = menu.open ? 'hidden' : '';
      if (menu.open) setHidden(header(), false);
    };
    menu.addEventListener('toggle', sync);
    close?.addEventListener('click', () => { menu.open = false; });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && menu.open) menu.open = false; });
  }

  function resetGate() { productReleased = false; lastBottomDelta = null; }
  function productGate(movingDown, movingUp) {
    if (!document.body.classList.contains('template-product') || width() < PRODUCT_DESKTOP_MIN) { resetGate(); return 'normal'; }
    const product = document.querySelector('.productView.pv2-active, .productView');
    const top = product?.querySelector('.productView-top');
    const left = product?.querySelector('.halo-productView-left');
    const right = product?.querySelector('.halo-productView-right, .productView-details');
    if (!top || !left || !right) return 'normal';
    const viewportH = height();
    if (!viewportH) return 'normal';
    const topRect = top.getBoundingClientRect();
    const leftRect = left.getBoundingClientRect();
    const rightRect = right.getBoundingClientRect();
    if (topRect.bottom <= 0) { productReleased = true; lastBottomDelta = null; return 'released'; }
    const bottomDelta = leftRect.bottom - rightRect.bottom;
    const gap = Math.abs(bottomDelta);
    const lowerBottom = Math.max(leftRect.bottom, rightRect.bottom);
    const crossed = lastBottomDelta !== null && ((lastBottomDelta > 0 && bottomDelta <= 0) || (lastBottomDelta < 0 && bottomDelta >= 0));
    lastBottomDelta = bottomDelta;
    const nearBottom = lowerBottom <= viewportH + VIEWPORT_ALLOWANCE;
    const clearlyPast = lowerBottom <= Math.max(180, viewportH * .55);
    if (!productReleased && movingDown && ((nearBottom && (gap <= MEET_TOLERANCE || crossed)) || clearlyPast)) productReleased = true;
    if (productReleased && movingUp && (gap > RELOCK_TOLERANCE || lowerBottom > viewportH + RELOCK_TOLERANCE)) productReleased = false;
    return productReleased ? 'released' : 'locked';
  }

  function setHidden(node, next) {
    if (!node) return;
    if (menuOpen()) next = false;
    next = Boolean(next);
    if (next === hidden) return;
    hidden = next;
    node.classList.toggle('is-scroll-hidden', next);
    document.documentElement.dataset.printoraHeaderHidden = next ? '1' : '0';
    window.dispatchEvent(new CustomEvent('printora:header-visibility', { detail: { hidden: next } }));
  }

  function update(node) {
    const current = y();
    const mobile = width() <= MOBILE_MAX;
    if ((mobile && current <= 0) || (!mobile && current <= TOP_SHOW) || menuOpen()) { anchorY = current; resetGate(); setHidden(node, false); return; }
    const movingDown = current > anchorY;
    const movingUp = current < anchorY;
    const gate = productGate(movingDown, movingUp);
    if (gate === 'locked') { anchorY = current; setHidden(node, false); return; }
    if (gate === 'released' && movingDown && !hidden) { anchorY = current; setHidden(node, true); return; }
    const delta = current - anchorY;
    const threshold = mobile ? MOBILE_THRESHOLD : DESKTOP_THRESHOLD;
    if (Math.abs(delta) < threshold) return;
    setHidden(node, delta > 0);
    anchorY = current;
  }

  function boot() {
    const node = header();
    if (!node || node.dataset.v27ScrollBound === '1') return;
    node.dataset.v27ScrollBound = '1';
    node.classList.add('pv27-header-scroll-ready');
    document.documentElement.dataset.printoraHeaderHidden = '0';
    anchorY = y();
    initAnnouncement();
    initMobileMenu();
    window.addEventListener('scroll', () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; update(node); }); }, { passive: true });
    window.addEventListener('resize', () => { anchorY = y(); resetGate(); setHidden(node, false); }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
